/* eslint-disable max-len */
define({
    ok: '확인',
    cancel: '취소',
    standardColors: '표준 색',
    customColors: '사용자 지정 색',
    recentColors: '최근에 사용한 색',
    preview: '미리보기',
    redTitle: 'R', // Used for label for three edit fields to enter [R, G, B] color
    greenTitle: 'G', // Used for label for three edit fields to enter [R, G, B] color
    blueTitle: 'B', // Used for label for three edit fields to enter [R, G, B] color
    hexTitle: '16진수', // Used for label for to enter hex color
    hueTitle: 'H', // Used for label for three edit fields to enter [H, S, V] color
    saturationTitle: 'S', // Used for label for three edit fields to enter [H, S, V] color
    valueTitle: 'V', // Used for label for three edit fields to enter [H, S, V] color
    doubleLabel: 'RGB [0~1]',
    intLabel: 'RGB [0~255]',
    hexLabel: '16진수',
    hsvLabel: 'HSV',
    auto: '자동',
    none: '없음',
    flat: '평탄',
    interp: '보간',
    texturemap: 'Texturemap',
    invalidHexErrorMessage: '값은 유효한 16진수 형식이어야 합니다.'
});
